import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './SummarySection.scss';

const SummarySectionHeader = ({
  children,
  className,
  asLabelFor,
  ...props
}) => (asLabelFor
  ? (
    <label htmlFor={asLabelFor} className={cx('SummarySectionHeader', className)} {...props}>
      {children}
    </label>
  ) : (
    <h2 className={cx('SummarySectionHeader', className)} {...props}>
      {children}
    </h2>
  )
);

SummarySectionHeader.propTypes = {
  asLabelFor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string
    ),
  ]),
};

SummarySectionHeader.defaultProps = {
  asLabelFor: '',
  children: null,
  className: undefined,
};

export default SummarySectionHeader;
